export default __webpack_public_path__ + "static/media/ZangXinForest.2064d051.jpg";